import { render, staticRenderFns } from "./LessonExplanation.vue?vue&type=template&id=3e044461&scoped=true"
import script from "./LessonExplanation.vue?vue&type=script&lang=js"
export * from "./LessonExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e044461",
  null
  
)

export default component.exports